import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Prompt } from 'react-router-dom';

import { NavigationLockout } from '@confluence/navigation-lockout';
import { fg } from '@confluence/feature-gating';

interface UnsavedNotificationCommentDraftPromptProps {
	onConfirm: () => void;
}

export const UnsavedNotificationCommentDraftPrompt: React.FC<
	UnsavedNotificationCommentDraftPromptProps
> = ({ onConfirm }) => {
	const intl = useIntl();

	return fg('confluence_frontend_transition_preloading_system') ? (
		<NavigationLockout message={intl.formatMessage(i18n.unsavedChanges)} onConfirm={onConfirm} />
	) : (
		<Prompt
			message={() => {
				if (confirm(intl.formatMessage(i18n.unsavedChanges))) {
					onConfirm();
					return true;
				}
				return false;
			}}
		/>
	);
};

const i18n = defineMessages({
	unsavedChanges: {
		id: 'app-navigation.notifications.unsaved-changes.confirm',
		defaultMessage: 'Do you want to discard this comment? Your comment will be lost if you do.',
		description:
			'Message displayed when there are unsaved changes in the notifications comment editor.',
	},
});
